// Landing-URL patterns used OUTSIDE React Router (main.tsx prefetch and
// route-chunk preload run before the router exists). Keep these in sync with
// the <Route path> definitions in App.tsx.

/** /business/:id -- captures the raw param (plain UUID or `<slug>-<uuid>`). */
export const BUSINESS_PAGE_PATH_RE = /^\/business\/([^/?#]+)\/?$/;
export const PRODUCT_DETAILS_PATH_RE = /^\/product-details\/[^/]+\/?$/;
export const DINE_IN_PATH_RE = /^\/dine-in\/[^/]+\/[^/]+\/?$/;
export const BUSINESS_COLLECTION_PATH_RE = /^\/collection\/[^/]+\/?$/;
export const LISTING_COLLECTION_PATH_RE = /^\/listing-collection\/[^/]+\/?$/;
